import React, { Component } from 'react'

class HybridDataField extends Component {

    render() {
        const { hybrid, allWeightUnits } = this.props;

        const allUnitsListItem = allWeightUnits.map((unit, i) =>
            unit.is_active === 1 ? <option selected={hybrid.weight_unit_id == unit.value} key={i} value={unit.value}>{unit.label}</option> : null
        );

        return (
            <div className="col-lg-5 mt-md-3">
                <div className="form-group acre-form-group d-flex align-items-center">
                    <label className="w-50 mb-0 qul-w font-weight-normal"> {hybrid.label}</label>
                    <div className="form-control selectbox">
                        <input type="number" placeholder="Quantity" defaultValue={hybrid.quantity} onChange={this.props._handleValueChange.bind(this, hybrid.label)} />
                        <select onChange={this.props.handleUnitChange.bind(this, hybrid.label)}>
                            {allUnitsListItem}
                        </select>
                    </div>
                </div>
            </div>
        )
    }
}

export default HybridDataField
